module.exports = __webpack_public_path__ + "img/parents-3.08b0f5fd.jpg";